class ArtikelListe extends HTMLElement {
    constructor() {
        super();
    }

    get componentName() {
        const componentName = this.getAttribute("component");
        if(!componentName) {
            return this.nodeName;
        }
        return componentName;
    }

    get isBrowserNavigation() {
        if (!this.sessionListKey) {
            return false;
        }
        const isBrowserNavigation = isNavigationTypeBackForward();
        return isBrowserNavigation;
    }

    connectedCallback() {
        this.sessionLoadUrl = `${this.componentName}.infiniteScroll.url`;
        this.sessionListKey = `${this.componentName}.infiniteScroll.html`;

        this.getElements();
        this.setEvents();
        if(this.isBrowserNavigation) {
            this.setBrowserNavigationData();
            this.clearSessionStorage();
        }
        window.addEventListener("beforeunload", (event) => {
            this.beforeunloadHandler(event);
        });
    }

    getElements() {
        this.artikelliste = this.querySelector(".tm-produktliste");
        this.moreArticlesButton = this.querySelector(".moreArticles");
        this.moreArticlesBox = this.querySelector(".moreArticlesBox");
    }

    setEvents() {
        if(this.moreArticlesButton) {
            this.moreArticlesButton.addEventListener('click', () => { this.handleClickMoreArticles(); });
        }
    }

    async handleClickMoreArticles() {
        const pagingAction = this.querySelector("input[name=pagingAction]");
        if (pagingAction) {
            pagingAction.remove();
        }
        const data = await this.getProductListData(this.moreArticlesButton.getAttribute("data-href"));
        this.artikelliste.innerHTML += data;
        this.setPagingAction();
    }

    setPagingAction() {
        const pagingAction = this.querySelector("input[name=pagingAction]");
        if (pagingAction) {
            const pagingActionVal = pagingAction.getAttribute("value");
            if (pagingActionVal === "") {
                this.moreArticlesBox.remove();
            } else {
                this.moreArticlesButton.setAttribute("data-href", pagingActionVal);
            }
        }
    }

    async getProductListData(url) {
        try {
            this.result = await fetch(url, {
                method: 'GET'
            })
                .then((res) => {
                    return res.text();
                })
                .then((data) => {
                    return data;
                })
                .catch((err) => {
                    throw new Error(err);
                });
            return this.result;
        } catch (e) {
            throw new Error(e);
        }
    }

    beforeunloadHandler(event) {
        const {
            activeElement        
        } = event.target;
        this.clearSessionStorage();
        if (!activeElement) return;
        this.writeSessionStorage();
    }

    writeSessionStorage() {
        const nachladeUrl = this.moreArticlesButton.dataset["href"];
        sessionStorage.setItem(this.sessionListKey, this.artikelliste.innerHTML);
        sessionStorage.setItem(this.sessionLoadUrl, nachladeUrl);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(this.sessionListKey);
        sessionStorage.removeItem(this.sessionLoadUrl);
    }

    setBrowserNavigationData() {
        const html = sessionStorage.getItem(this.sessionListKey);
        if (html !== null) {
            this.artikelliste.innerHTML = html;
        }
        const nachladeUrl = sessionStorage.getItem(this.sessionLoadUrl);
        if (nachladeUrl !== null) {
            this.moreArticlesButton.dataset["href"] = nachladeUrl;
        }
    }

}

function isNavigationTypeBackForward() {
    if (!window.performance) {
        return false;
    }
    const navigationType = window.performance.getEntriesByType("navigation")[0];
    if (!navigationType) {
        return false;
    }
    return navigationType.type === "back_forward";
}

if (!customElements.get("artikel-liste")) {
    customElements.define("artikel-liste", ArtikelListe);
}
